export { LegalConsentPage } from './src/legal-consent-page';
export { CONSENT_PAGE_LEGAL_DISPLAY_TEXT_VERSION } from './src/constants';
